// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@eisinc/MobiusOverrides/Tooltip/Tooltip";
import LinkInfo from "@eisinc/XDL/Icons/LinkInfo";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xBaseTheme } from "@eisinc/XDL/types";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            triggerWrapper: {
                css: css`
                    margin-left: 4px;
                    margin-right: 4px;
                    display: inline-flex;
                `,
            },
            tooltipContent: {
                css: css`
                    padding: 8px;
                    font-size: ${fontConfig.singleLinexSmall.size}px;
                    line-height: ${fontConfig.singleLinexSmall.lineHeight};
                    max-width: 300px;
                    color: ${color("text.main")};
                    background-color: ${color("common.ui1")};
                    box-shadow: 0 0 4px 0 ${color("common.black", 0.25)};
                    text-align: left;
                    border-radius: 0;
                    min-width: 160px;
                `,
            },
        },
        iconProps: {
            src: LinkInfo,
            width: 14,
            height: 17,
            color: "primary",
            css: css`
                cursor: pointer;
                &:hover {
                    color: ${color("common.ui8")};
                }
            `,
        },
        typographyProps: {
            ...fontConfig.singleLinexSmall,
            css: css`
                color: ${color("text")};
                letter-spacing: 0;
                text-align: center;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
        titleTypographyProps: {
            ...fontConfig.singleLinexSmall,
            css: css`
                letter-spacing: 0;
                margin-bottom: 5px;
                font-weight: 400;
                color: ${color("text")};
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
